function fn_layout_main() {
    $("body").removeClass("mod--preload");
    setTimeout(function () {
        $("body").addClass("mod--loaded");
    }, 300);

    fn_scrollreveal();
    fn_nl_lib_anchor();

    $(".lib--parallax").find("img:not(.lazyload)").parent().parallax();
    $(document).on('lazybeforeunveil', function (e) {
        if ($(e.target).parent().hasClass("lib--parallax")) {
            $(e.target).parent().parallax();
        }
    });

    nl_lib_dialog.init();
    $("[data-switch]").nl_lib_switch();

    if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
        $("html").addClass("ie10");
    }

    if (((navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) && (parseInt(navigator.userAgent.substring(navigator.userAgent.indexOf("Version") + 8)) < 11))) {
        $("html").addClass("safari");
    }

    $(document).on("click", "[data-gallery]", function (e) {
        e.preventDefault();
        var $gallery_data = $(this).data('gallery');
        $(this).lightGallery({
            dynamic: true,
            actualSize: false,
            zoom: false,
            dynamicEl: $gallery_data
        });
    });

    // AJAX FORM //
    $(document).on('submit', 'form.ajax', function (e) {
        e.preventDefault();
        var $frm = $(this);
        var formData = new FormData($(this)[0]);
        $.ajax({
            method: $frm.attr('method'),
            url: $frm.attr('action'),
            data: formData,
            processData: false,
            contentType: false
        });
    });

    // ALAX LINKS
    $(document).on('click', '[href].ajax', function (e) {
        e.preventDefault();
        var $el = $(this);
        $.ajax({
            url: $el.attr('href')
        }).done(function () {
            if ($("[data-form-datepicker]").length) {
                fn_part_form_ride();
            }
        });
    });

    var antispam = function () {
        if ($('#snipet-newsletter').length) {
            setTimeout(function () {
                $('#snipet-newsletter').append('<input type="hidden" class="text" name="antispam" value="antispam" />');
            }, 3000);
        }
    };
    antispam();

    /* GLOBAL AJAX EVENT HANDLER */
    $.ajaxSetup({
        success: function (payload) {
            if (payload) {
                // přesměrování "this" přesměruje na aktuální stránku
                if (payload.redirect) {
                    if (payload.redirect == 'this') {
                        location.href = window.location.href.split("#")[0];
                    } else {
                        location.href = payload.redirect;
                    }
                }

                // výměna snippetů v šabloně - každý snipper musí mít unikátní ID
                if (payload.snippets) {
                    for (var i in payload.snippets) {
                        $("#" + i).replaceWith(payload.snippets[i]);
                    }
                }

                // výměna adresy v adresním řádku
                if (payload.replaceState) {
                    window.history.replaceState(null, payload.replaceState.title || null, payload.replaceState.url);

                    if (payload.replaceState.title) {
                        document.title = payload.replaceState.title;
                    }

                    if (typeof window.ga === "function") {
                        ga('send', 'pageview', window.location.pathname + window.location.search);
                    }
                }

                // dialogy přes newlogic UI
                if (payload.dialog) {
                    nl_lib_dialog.open(payload.dialog);
                }
                antispam();
                sr.sync();
                if (!$(".lib--zoom-init").length && $(".lib--zoom").length) {
                    $('.lib--zoom').Chocolat({
                        imageSize: 'cover',
                        imageSelector: '.elm_bike'
                    });
                }
            }
        },
        dataType: "json"
    });

// timeline
    /*$(document).on('click', 'a.ajax', function (e) {
     e.preventDefault();
     var $el = $(this);
     $('.ajax').removeClass('mod--active');
     $($el).addClass('mod--active');
     $.ajax({
     url: $el.attr('href')
     }).done(function () {
     if ($("[data-form-datepicker]").length) {
     fn_part_form_ride();
     }
     });
     
     });*/

// kontrola poctu fotek
    $(document).on('click', '.sendForm', function (e) {
        var text = $(this).data('text');
        var $fileUpload = $("input[type='file']");
        //console.log($fileUpload.get(0).files);
        if (parseInt($fileUpload.get(0).files.length) > 5) {
            alert(text);
            return false;
        }
    });


// vyber velikosti
    $(document).on('click', '.selectSizeBike', function (e) {
        $(this).closest('.elm_step_type').find('.part_ui_btn_circle').removeClass('mod--active');
        $.ajax({
            data: {do: 'selectSizeBike', sizeBike: $(this).val()}
        });
    });

    // vyber mesta
    $(document).on('click', '.selectTownBike', function (e) {
        $.ajax({
            data: {do: 'selectTownBike', townBike: $(this).val()}
        });
    });

    // vyber datumu
    $(document).on('change', '#dateFrom', function (e) {
        $.ajax({
            data: {do: 'selectDateBike', dateFrom: $('#dateFrom').val()}
        });
    });

    // vyber datumu2
    $(document).on('change', '#dateTo', function (e) {
        $.ajax({
            data: {do: 'selectDateBike2', dateTo: $('#dateTo').val()}
        });
    });

    // vyber time
    $(document).on('blur', '#timeFrom', function (e) {
        $.ajax({
            data: {do: 'selectTimeBike', timeFrom: $('#timeFrom').val()}
        });
    });

    // vyber time2
    $(document).on('blur', '#timeTo', function (e) {
        $.ajax({
            data: {do: 'selectTimeBike2', timeTo: $('#timeTo').val()}
        });
    });

    // CONFIGURATION
    $(document).on('change', '[data-component-select-part]', function () {
        var $elm = $(this);
        var $option = $elm.find(":selected");

        $('[data-component-name]').text($option.data('name'));
        $('[data-component-description]').text($option.data('description'));
        $('[data-component-price]').text($option.data('price'));
        $('[data-component-weight]').text($option.data('weight'));
        $('[data-component-image]').attr('src', $option.data('image'));

    });

    $(document).on('change', '[data-change-frame]', function () {
        var $this = $(this);

        $.ajax({
            method: 'post',
            data: {do: 'selectItem', component: $this.data('component'), item: $this.val()}
        });
    });

    $(document).on('click', '[data-component-confirm]', function () {
        var $select = $('[data-component-select-part]');

        $.ajax({
            method: 'post',
            data: {do: 'selectItem', component: $select.data('component'), item: $select.val()}
        });
    });

    if ($('.comp_basket').length) {
        var checkShipping = function () {
            $('[name=payment]').prop('disabled', false);

            // osobni odber
            if ($('input[name="shipping"]:checked').val() == 1 || $('input[name="shipping"]:checked').val() == 2) {
                $('[name=payment][value=2]').prop('disabled', true).prop('checked', false); // disable dobirka
            }

            // doprava čr
            if ($('input[name="shipping"]:checked').val() == 3) {
                $('[name=payment][value=1]').prop('disabled', true).prop('checked', false); // disable hotově
            }

            // doprava sr
            if ($('input[name="shipping"]:checked').val() == 4) {
                $('[name=payment][value=1]').prop('disabled', true).prop('checked', false); // disable hotově
                $('[name=payment][value=2]').prop('disabled', true).prop('checked', false); // disable dobirka
            }
        };

        var checkPayment = function () {
            if ($('input[name="payment"]:checked').val() == 2) {
                $('[data-price-cod]').each(function () {
                    var $elm = $(this);
                    $elm.text($elm.data('price-cod'));
                });
            } else {
                $('[data-price-cod]').each(function () {
                    var $elm = $(this);
                    $elm.text($elm.data('price-default'));
                });
            }
        };

        $(document).on('change', '[name="shipping"]', checkShipping);
        $(document).on('change', '[name="payment"]', checkPayment);

        checkShipping();
        checkPayment();
    }
}